<div
  class="search-box"
  [class.search-box--map-visible]="isMapVisible"
  [class.search-box--dropdown-open]="isDropdownOpen"
  [class.search-box--has-active-region]="hasActiveRegion"
  [class.search-box--has-multiple-active-regions]="hasMultipleActiveRegions"
  [class.search-box--hide-radius]="hasMultipleActiveRegions || forceHideRadius"
>
  <div class="search-box__box" cdkOverlayOrigin #origin="cdkOverlayOrigin">
    <i class="search-box__icon material-icon material-icon--outlined">
      search
    </i>

    <div class="search-box__input">
      <lib-search-input
        #searchInput
        [placeholderText]="placeholderText"
        [activeRegions]="activeRegions"
        [formControl]="searchControl"
        [withChips]="withChips"
        (escape)="onEscape()"
        (enter)="onEnter()"
        (focused)="onInputFocus()"
        (openMobileFilters)="onOpenMobileFilter()"
      >
      </lib-search-input>
    </div>

    <div class="search-box__radius-dropdown">
      <lib-radius-dropdown [options]="radiusOptions"></lib-radius-dropdown>
    </div>

    <div class="search-box__reset" *ngIf="!disableReset">
      <button class="mobile-reset-button" (click)="removeAllRegions()">
        <i class="material-icon material-icon--outlined"> close </i>
      </button>

      <button class="desktop-reset-button" (click)="removeAllRegions()">
        {{ 'filters.common.reset' | i18n }}
      </button>
    </div>

    <div class="search-box__filter-button">
      <button class="filter-button" (click)="onOpenMobileFilter()">
        <i class="filter-button__icon material-icon material-icon--outlined">
          tune
        </i>
      </button>
    </div>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isDropdownOpen"
    [cdkConnectedOverlayLockPosition]="true"
    [cdkConnectedOverlayGrowAfterOpen]="true"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayWidth]="origin.elementRef.nativeElement.clientWidth + 2"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    [cdkConnectedOverlayViewportMargin]="16"
    (overlayOutsideClick)="close()"
    (detach)="close()"
  >
    <div class="search-box__results">
      <ul class="search-box__result-list" *ngIf="!hasNoResults">
        <li
          class="search-box__result"
          *ngFor="let option of options; let i = index; trackBy: trackBy"
          (click)="select(option)"
        >
          <button
            class="search-box-result"
            [class.search-box-result--highlighted]="activeResultIndex === i"
            (mousemove)="focusResult(i)"
            #resultButton
          >
            <i
              class="search-box-result__icon material-icon material-icon--outlined"
            >
              search
            </i>

            <span class="search-box-result__text">
              {{ option.text }}
            </span>

            <span
              class="search-box-result__type"
              *ngIf="getPlaceType(option)"
              >{{ getPlaceType(option)! | i18n }}</span
            >
          </button>
        </li>
      </ul>

      <div class="search-box__no-results" *ngIf="hasNoResults">
        <div class="no-results">
          <i class="no-results__icon material-icon material-icon--error">
            report_problem
          </i>

          <span class="no-results__text">
            {{ 'filters.search.noResults' | i18n }}
          </span>
        </div>
      </div>
    </div>
  </ng-template>
</div>
